/**
 * Code-only product terms for the Trails / co-curricular pathways feature.
 * Same strings for every instance in MVP — no per-instance terminology prefs.
 * Import these constants everywhere; do not hardcode strings in components.
 */

export const TrailLabels = {
    TRAIL: "Trail",
    TRAILS: "Trails",
    SUMMIT: "Summit",
    SUMMITS: "Summits",
    AWARD: "Award",
    AWARDS: "Awards",
    CURRICULUM: "Curriculum",
    CURRICULA: "Curricula",
    COHORT: "Cohort",
    COHORTS: "Cohorts",
    FOCUS_AREA: "Focus Area",
    FOCUS_AREAS: "Focus Areas",
    TRACK: "Track",
    TRACKS: "Tracks",
    REQUIREMENT: "Requirement",
    REQUIREMENTS: "Requirements",
    PROGRESS: "Progress",
    CATALOG: "Catalog",
    EXPERIENCE: "Experience",
    EXPERIENCES: "Experiences",
    ENDING_AWARD: "Ending Award",

    SUMMIT_EARNED: "Summit Earned",
    AWARD_EARNED: "Award Earned",
    DECLARED: "Declared",
    AWARDED: "Awarded",
    TRACK_EARNED: "Track Earned",
    GRANDFATHERED_DEFN: "You completed this curriculum under prior requirements.",
    GRANDFATHERED_SUMMIT: "Summit earned under prior requirements.",
    GRANDFATHERED_TRACK: "Track earned under prior requirements.",
    UPDATE_PROGRESS: "Update My Progress",
    DECLARE: "Declare",
    DROP_DECLARATION: "Drop pathway",
    SAVE_TRACKS: "Save tracks",
    MY_PATHWAYS: "My Pathways",
    AVAILABLE_TO_ME: "Available to Me",
    ALL_PATHWAYS: "All Pathways",
    SUBMIT_EXPERIENCE: "Submit Experience",
    VIEW_PROGRESS: "View Progress",
    BROWSE_CATALOG: "Browse Pathways",
    MY_TRAILS: "My Trails",

    NOT_YET_OPEN: "Not Yet Open",
    EXPIRED: "Expired",
    LOCKED: "Locked",
    SATISFIED: "Satisfied",
    IN_PROGRESS: "In Progress",
    NOT_STARTED: "Not Started",

    APPROVAL_PENDING: "Pending Approval",
    APPROVED: "Approved",
    DENIED: "Denied",

    DRAFT: "Draft",
    PUBLISHED: "Published",
    DISABLED: "Disabled",

    MY_EXPERIENCES: "My Experiences",
    REVIEW_EXPERIENCES: "Experience Reviews",
    APPROVAL_REASON: "Approval Reason",
    DENIAL_REASON: "Denial Reason",
    NO_EXPERIENCES: "No experiences submitted yet",
    NO_AWARDS: "No awards to display",
    NO_TRAILS: "No trails to display",
    APPROVE: "Approve",
    DENY: "Deny",
    CATALOG_DESCRIPTION: "Catalog Description",
    AVAILABILITY_RULES: "Availability Rules",
    GRANT_APPROVAL: "Grant Approval",
    REVOKE_APPROVAL: "Revoke Approval",
    OVERRIDE: "Override",
    OVERRIDE_REASON: "Reason for override",
    CLEAR_OVERRIDE: "Clear override",
    WAIVED: "Waived",
    REQUIRES_ADVISOR_APPROVAL: "Requires advisor approval",
    STUDENT_PROGRESS: "Student Progress",
    TRAIL_ICON: "Trail Icon",
    PREVIEW_AS_STUDENT: "Preview as student",
    PREVIEW_STUDENT_OPTIONAL: "Optional student",
    PREVIEW_STUDENT_HINT: "Choose a student to view their progress, or leave empty to preview as yourself.",
    CANNOT_COMBINE_WITH: "Cannot be combined with",

    MUST_COMPLETE_ALL_BELOW: "Must complete all directly below",
    COMPLETE_ANY_BELOW: "Complete any directly below",
    COMPLETE_N_OF_BELOW: "Complete {n} of the items directly below",
    EARN_N_CREDITS_BELOW: "Earn {n} credits from the items directly below",
    SUBMIT_AN_EXPERIENCE: "Submit an experience",
    ADVISOR_APPROVAL: "Advisor approval",
    EARN_A_BADGE: "Earn a badge",
    ATTEND_EVENTS: "Attend events",
    COMPLETE_SERVICE_HOURS: "Complete service hours",
    HOLD_AN_ORG_ROLE: "Hold an organization role",
    COMPLETE_A_TRAIL: "Complete a trail",
    INCLUDED_REQUIREMENTS: "Included requirements",
} as const;

export type TrailLabel = (typeof TrailLabels)[keyof typeof TrailLabels];
